import React from "react";

const DotGridImage = 'https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/dot-grid.png'

const DotGrid = ({
  className,
  size = 10
}: {
  className?: string;
  size?: number;
}) => (
  <div className={className}>
    <img src={DotGridImage} alt="Dot grid"/>
  </div>
);

export default DotGrid;
